// src/frontend_react/src/components/ui/Button/Button.js
import React from 'react';
import styles from './Button.module.css';
import Spinner from '../Spinner/Spinner';

const Button = ({
  children,
  onClick,
  type = 'button',
  variant = 'primary',
  size = 'md',
  leftIcon,
  rightIcon,
  disabled = false,
  isLoading = false,
  fullWidth = false,
  isIconOnly = false,
  className = '',
  title,
  ariaLabel,
  // --- FIX: Consume layout rest ---
  style,
  alignSelf,
  flexGrow,
  ...rest
}) => {
  const combinedClassName = [
    styles.button,
    styles[variant] || styles.primary,
    styles[size] || styles.md,
    isLoading ? styles.loading : '',
    isIconOnly ? styles.iconOnly : '',
    fullWidth ? styles.fullWidth : '',
    className,
  ].filter(Boolean).join(' ');

  const actualAriaLabel = ariaLabel || (typeof children === 'string' ? children : title);

  const buttonStyle = { ...style };
  if (alignSelf) buttonStyle.alignSelf = alignSelf;
  if (flexGrow) buttonStyle.flexGrow = flexGrow;

  return (
    <button
      type={type}
      onClick={onClick}
      className={combinedClassName}
      disabled={disabled || isLoading}
      title={title}
      aria-label={actualAriaLabel}
      style={buttonStyle}
      {...rest}
    >
      {isLoading ? (
        <Spinner size="sm" color="currentColor" />
      ) : (
        <>
          {leftIcon && <span className={styles.iconWrapperLeft}>{leftIcon}</span>}
          {!isIconOnly && children}
          {isIconOnly && children}
          {rightIcon && !isIconOnly && <span className={styles.iconWrapperRight}>{rightIcon}</span>}
        </>
      )}
    </button>
  );
};

export default Button;